import { applyMiddleware, createStore, compose, combineReducers } from "redux";
import { persistStore, autoRehydrate } from "redux-persist";
import crosstabSync from "redux-persist-crosstab";
import createSagaMiddleware from "redux-saga";
import events from "./reducers/events";
import users from "./reducers/users";
import app from "./reducers/app";

const reducer = combineReducers({
  app,
  events,
  users
});

const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware];

const composeCreateStore = () =>
  compose(
    applyMiddleware(...middlewares),
    autoRehydrate(),
    window.devToolsExtension ? window.devToolsExtension() : fn => fn
  )(createStore);

const configureStore = port => {
  const finalCreateStore = composeCreateStore(port);
  const store = {
    ...finalCreateStore(reducer),
    runSaga: sagaMiddleware.run
  };

  // if (module.hot) {
  // 	module.hot.accept('./reducers', () => store.replaceReducer(reducer))
  // }

  let persistor = persistStore(store);
  crosstabSync(persistor);

  return { store, persistor };
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store.js